import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logestic-page',
  templateUrl: './logestic-page.component.html',
  styleUrls: ['./logestic-page.component.scss']
})
export class LogesticPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
